import * as React from 'react';
import { SelectType } from './types';
import styles from './select-option.scss';
import { BreakLines } from 'app/components/break-lines';

export interface SelectOptionProps {
  selectType?: SelectType;
  hasChildren?: boolean;
  longDescription?: string;
}

export class SelectOption extends React.Component<SelectOptionProps> {

  public render() {
    const { hasChildren, children, longDescription } = this.props;
    const selectTypeClass = styles.selectCheck;
    const hasChildrenClass = hasChildren ? styles.selectHasChildren : '';

    return <li className={`form-check ${selectTypeClass}`}>
      <div className={hasChildrenClass}>{children}</div>
      {!!longDescription && <div className={styles.longDescription}>
        <BreakLines text={longDescription} />
      </div>}
    </li>;
  }
}
